module.exports = __webpack_public_path__ + "static/media/angry-face.857cfdd4.svg";